//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObject.js";
import "../no/SketchTypes.js";
import "../no/ugmath.js";
let d=[[],[[["selectedObjects"],"CreatePreviewDimensions",{},1,0],[["dimensionCount"],"GetPreviewDimensions",{R_:{dimensionConstraints:"SketchDimensionalConstraint[]"}},0,0],[["previewDimension"],"CreateDimensionFromPreview",{R_:{dimension:"SketchDimensionalConstraint"}},1,0],[[],"DeletePreviewDimensions",{},0,0]],[]];
SPLM.SketchDimensionPreviewer = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchDimensionPreviewer";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;